import * as S from "./BottomBanner.styles";

import { ClosePrimaryIcon } from "@ubnt/icons";
import { Cookies } from "react-cookie";
import React, {
  type PropsWithChildren,
  useCallback,
  useEffect,
  useState,
} from "react";
import { useSiteSettings } from "context/SiteSettingsContext";
import { StoreId } from "@ubnt/store.core/lib/types";

const cookies = new Cookies();

const BANNER_CLOSED_VALUE = 1;

export const BottomBanner = ({
  href,
  cookieName,
  backgroundColor,
  children,
  disabledStores,
}: Readonly<
  PropsWithChildren<{
    href: string;
    backgroundColor?: string;
    cookieName: string;
    disabledStores?: StoreId[];
  }>
>) => {
  const { store } = useSiteSettings();

  const [isClosedLocal, setIsClosedLocal] = useState(false);
  const isBannerHidden = cookies.get(cookieName) === BANNER_CLOSED_VALUE;

  const onCloseBanner = useCallback(
    (event?: React.MouseEvent<HTMLButtonElement>) => {
      event?.preventDefault();

      setIsClosedLocal(true);
      cookies.set(cookieName, String(BANNER_CLOSED_VALUE), {
        path: "/",
        expires: undefined,
        secure: true,
        sameSite: "strict",
      });
    },
    [cookieName],
  );

  useEffect(() => {
    if (isBannerHidden) {
      return;
    }

    if (disabledStores?.includes(store.id)) {
      onCloseBanner();
    }
  }, [isBannerHidden, onCloseBanner, store.id, disabledStores]);

  if (isClosedLocal || isBannerHidden) {
    return null;
  }

  return (
    <S.FixedContainer
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      $backgroundColor={backgroundColor}
    >
      <S.Wrapper
        size="desktop"
        noVerticalMargin
        $spacing={{ top: 0, bottom: 0 }}
      >
        <S.GradientLeft $backgroundColor={backgroundColor} />

        {children}

        <S.TransparentButton aria-label="Close Banner" onClick={onCloseBanner}>
          <ClosePrimaryIcon size={20} color="#fff" />
        </S.TransparentButton>

        <S.GradientRight $backgroundColor={backgroundColor} />
      </S.Wrapper>
    </S.FixedContainer>
  );
};
